import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

export const SUPPORTED_LANGS = ['en', 'fr', 'es', 'pt'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      // PT's MINOR slot is repurposed as "Dupla Graduação" (dual degree) and
      // its dropdown options are the PT majors list — no separate curriculum.
      // Aliasing here keeps the 47-item list defined once in pt.json:majors;
      // pt.json:minors stays `[]` purely for key-shape parity with the other
      // locale files.
      pt: { translation: { ...pt, minors: pt.majors } },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true, // map "en-US" → "en"
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'oc-lang',
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    returnObjects: true,
  });

export default i18n;
